export default __webpack_public_path__ + "static/media/Katamya-Hospital.e3f873fe.svg";